/**
 * Highlight This: finds and marks words
 *
 * Exposes no reachable web-accessible resource, but its content script injects a
 * vendor-named stylesheet — `<style id="HighlightThisStyles">` — into the document head
 * on every page while active. Found with `tooling/probe-interactions.js`: the element
 * appeared on a plain bait page with no user action.
 *
 * The `HighlightThisStyles` id is product-specific, so it identifies this extension
 * rather than "some highlighter". Behavioural, so it only fires while the content script
 * is active.
 *
 * Observed on version 6.3.12.
 */

import { probeSelector } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'fgmbnmjmbjenlhbefngfibmjkpbcljaj';

export const highlightThis: ExtensionDefinition = {
  id: ID,
  name: 'Highlight This: finds and marks words',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  interactive: true,
  notes:
    'Detected behaviourally: injects style#HighlightThisStyles into the head on every ' +
    'page. No reachable web-accessible resource, so this is the signal.',
  signals: [
    {
      id: 'dom-highlight-this-style',
      kind: 'dom',
      description:
        'Look for style#HighlightThisStyles — the vendor-named stylesheet the extension ' +
        'injects into the head while its content script is active.',
      weight: 1,
      run: () => probeSelector('style#HighlightThisStyles', { timeoutMs: 2500 }),
    },
  ],
};
